import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import tableStyles from '../tables/tableStyles';
import config from '../../config';

interface TableNoDataPlaceholderProps {
  entity: string;
}

const TableNoDataPlaceholder: React.FC<TableNoDataPlaceholderProps> = ({ entity }) => {
  const spaceUrl: string = config.gChatSupportSpace;

  return (
    <Box sx={tableStyles.tableNoDataPlaceholderBox}>
      <Typography sx={tableStyles.tableNoDataPlaceholderText}>
        Oops! {entity} devices not found.
        <br />
        Please get in touch with{' '}
        <Link href={spaceUrl} target="_blank">
          #ncc-support
        </Link>{' '}
        in gChat for further assistance.
      </Typography>
    </Box>
  );
};

export default TableNoDataPlaceholder;
